import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Section, SectionHeadline } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { StyledCTAButton, SignUpButtonContent, StyledArrowRight } from "@faire/retailer-visitor-shared/views/careers/ViewOpeningsButton";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import careers from "@faire/web-api--source/routes/careers";
import React from "react";
import styled from "styled-components";
export var LearnMoreSection = function() {
    return /*#__PURE__*/ _jsxs(Section, {
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        $backgroundColor: Decorative.shade.yellow,
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(StyledHeadline, {
                color: Core.text.inverse,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "80Kpbw",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn more about life at Faire"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    desktopAndAbove: "5x",
                    mobileAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsx(BorderlessButton, {
                variant: "secondary",
                linkTo: careers(),
                children: /*#__PURE__*/ _jsxs(SignUpButtonContent, {
                    children: [
                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "j5XyU9",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Learn More"
                                }
                            ]
                        }),
                        /*#__PURE__*/ _jsx(StyledArrowRight, {})
                    ]
                })
            })
        ]
    });
};
var BorderlessButton = styled(StyledCTAButton).withConfig({
    componentId: "sc-469a18df-0"
})([
    "border:none;"
]);
var StyledHeadline = styled(SectionHeadline).withConfig({
    componentId: "sc-469a18df-1"
})([
    "width:auto;",
    "{width:300px;}"
], responsiveMediaQueries.tabletAndBelow);
